import type { TranslationMessages } from '../types';

export const bonuses: TranslationMessages = {
      title: 'Thưởng',
      create: 'Tạo Thưởng',
      edit: 'Chỉnh Sửa Thưởng',
      name: 'Tên',
      name_placeholder: 'ví dụ: Thưởng Cuối Tuần',
      description: 'Mô Tả',
      description_placeholder: 'Mô tả tùy chọn',
      entity_type: 'Loại Thực Thể',
      'entity_type.shift': 'Ca',
      'entity_type.attendance': 'Chấm Công',
      'entity_type.performance': 'Hiệu Suất',
      'entity_type.other': 'Khác',
      position: 'Vị Trí',
      all_positions: 'Tất Cả Vị Trí',
      'position.barista': 'Barista',
      'position.cashier': 'Thu Ngân',
      'position.manager': 'Quản Lý',
      'position.cook': 'Đầu Bếp',
      'position.server': 'Phục Vụ',
      staffing_type: 'Loại Nhân Viên',
      all_staffing_types: 'Tất Cả Loại Nhân Viên',
      time_of_day: 'Thời Gian Trong Ngày',
      'time_of_day.morning': 'Sáng',
      'time_of_day.afternoon': 'Chiều',
      'time_of_day.evening': 'Tối',
      'time_of_day.night': 'Đêm',
      'time_of_day.custom': 'Khoảng Thời Gian Tùy Chỉnh',
      any_time: 'Bất Kỳ Thời Gian Nào',
      custom_time_range: 'Khoảng Thời Gian Tùy Chỉnh',
      start_time: 'Thời Gian Bắt Đầu',
      end_time: 'Thời Gian Kết Thúc',
      days_of_week: 'Ngày Trong Tuần',
      'day.sunday': 'Chủ Nhật',
      'day.monday': 'Thứ Hai',
      'day.tuesday': 'Thứ Ba',
      'day.wednesday': 'Thứ Tư',
      'day.thursday': 'Thứ Năm',
      'day.friday': 'Thứ Sáu',
      'day.saturday': 'Thứ Bảy',
      bonus_amount: 'Số Tiền Thưởng',
      currency: 'Tiền Tệ',
      is_active: 'Hoạt Động',
      conditions: 'Điều Kiện',
      all_conditions: 'Tất Cả Điều Kiện',
      status: 'Trạng Thái',
      active: 'Hoạt Động',
      inactive: 'Không Hoạt Động',
      actions: 'Hành Động',
      search: 'Tìm kiếm thưởng...',
      no_bonuses: 'Không tìm thấy thưởng nào.',
      cancel: 'Hủy',
      save: 'Lưu',
      saving: 'Đang lưu...',
      delete: 'Xóa',
      delete_title: 'Xóa Thưởng',
      delete_confirm:
        'Bạn có chắc chắn muốn xóa thưởng này không? Hành động này không thể hoàn tác.',
      create_success: 'Tạo thưởng thành công',
      create_error: 'Không thể tạo thưởng',
      update_success: 'Cập nhật thưởng thành công',
      update_error: 'Không thể cập nhật thưởng',
      delete_success: 'Xóa thưởng thành công',
      delete_error: 'Không thể xóa thưởng',
      load_error: 'Không thể tải thưởng',
      validation_error: 'Vui lòng điền vào tất cả các trường bắt buộc',
      user_required: 'Thông tin người dùng là bắt buộc',
    };
